import { render, staticRenderFns } from "./OIdInfo.vue?vue&type=template&id=8ea202aa&"
import script from "./OIdInfo.vue?vue&type=script&lang=js&"
export * from "./OIdInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports